type EventPayload = {
  form_id?: string;
  module?: string;
  page_path?: string;
  [key: string]: unknown;
};

export const getModuleFromPath = (path: string) => {
  if (path === '/') return 'platform';
  if (path.startsWith('/modules/sms')) return 'sms';
  if (path.startsWith('/sms-airlines')) return 'sms';
  if (path.startsWith('/modules/lms')) return 'lms';
  if (path.startsWith('/modules/eaip')) return 'eaip';
  if (path.startsWith('/modules/pans-ops')) return 'pans_ops';
  if (path.startsWith('/modules/utm')) return 'utm';
  if (path.startsWith('/modules/ai-assistant')) return 'ai_assistant';
  if (path.startsWith('/try-ai')) return 'ai_assistant';
  if (path.startsWith('/flymate')) return 'ai_assistant';
  if (path.startsWith('/sms-regulatory')) return 'sms';
  if (path.startsWith('/lms-aviation-authority')) return 'lms';
  if (path.startsWith('/safety-governance')) return 'safety';
  if (path.startsWith('/solutions')) return 'platform';
  if (path.startsWith('/compliance')) return 'platform';
  if (path.startsWith('/pricing')) return 'platform';
  if (path.startsWith('/about')) return 'platform';
  if (path.startsWith('/blog')) return 'blog';
  if (path.startsWith('/public-portal')) return 'lms';
  if (path.startsWith('/contact')) return 'platform';
  return 'platform';
};

export const trackEvent = (eventName: string, payload: EventPayload = {}) => {
  if (typeof window === 'undefined') return;
  const pagePath = payload.page_path || window.location?.pathname || '';
  const module = payload.module || getModuleFromPath(pagePath);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    page_path: pagePath,
    module,
    ...payload,
  });
};
